
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 200 200"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M174.98 100.165a13.954 13.954 0 01-4.1 9.734l-45.961 45.962c-5.468 5.468-14.332 5.468-19.8 0-5.467-5.467-5.467-14.331 0-19.799l21.381-21.381-89.5.001c-7.732 0-14-6.268-14-14s6.268-14 14-14l90.901-.001-22.781-22.782c-5.468-5.467-5.468-14.331 0-19.798 5.467-5.468 14.331-5.468 19.799 0l45.961 45.961a13.954 13.954 0 014.1 9.735z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    